export const LibConfig = {
  apiDomain: 'https://hotels.cloudbeds.com',
};
